import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { initializeAuth } from '../features/auth/authSlice'
import { selectIsInitialized, selectIsAuthenticated } from '../features/auth/authSlice'
import type { RootState } from '../store/store'
import { Logger } from '../lib/utils'

interface AuthInitializerProps {
  children: React.ReactNode
}

export const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const isInitialized = useSelector((state: RootState) => selectIsInitialized(state))
  const isAuthenticated = useSelector((state: RootState) => selectIsAuthenticated(state))
  const isLoginPage = location.pathname === '/login'

  useEffect(() => {
    if (!isInitialized) {
      Logger.debug('AuthInitializer: Inicializando autenticación')
      dispatch(initializeAuth())
    }
  }, [dispatch, isInitialized])

  useEffect(() => {
    // Esta lógica solo aplica cuando ya sabemos el estado de autenticación
    if (isInitialized) {
      Logger.debug(`AuthInitializer: Estado - Autenticado: ${isAuthenticated}, Ruta: ${location.pathname}`)

      // Si no está autenticado y no está en login, redirigir a login
      if (!isAuthenticated && !isLoginPage) {
        Logger.debug('AuthInitializer: Redirigiendo a login por falta de autenticación')
        navigate('/login', { replace: true })
      }
      
      // Si está autenticado y está en login, redirigir al dashboard
      if (isAuthenticated && isLoginPage) {
        Logger.debug('AuthInitializer: Redirigiendo a dashboard (usuario ya autenticado)')
        navigate('/', { replace: true })
      }
    }
  }, [isInitialized, isAuthenticated, isLoginPage, navigate, location.pathname])

  // No renderizar nada hasta que la autenticación esté inicializada
  if (!isInitialized) {
    return null // O un componente de carga si lo prefieres
  }

  return <>{children}</>
} 